import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('order');

export const state = () => ({
    ...crud.state,
    CREATED: 'created',
    PAID: 'paid',
    SENT: 'sent',
    SHIPPING: 'shipping',
    ARRIVED: 'arrived',
    COLLECTED: 'collected',
    REFUNDED: 'refunded',
    CANCELLED: 'cancelled',
    PAYMENT_METHOD_STARS: 'stars',
    PAYMENT_METHOD_CREDIT: 'credit',
    PAYMENT_METHOD_MANUAL: 'manual',
    PAYMENT_METHOD_CREDIT_AND_STARS: 'credit&stars'
});

export const getters = {
    ...crud.getters,
    ALL_STATUSES: state => [
        { text: 'Created', value: state.CREATED },
        {
            text: 'Paid',
            value: state.PAID
        },
        {
            text: 'Sent',
            value: state.SENT
        },
        {
            text: 'Shipping',
            value: state.SHIPPING
        },
        { text: 'Arrived', value: state.ARRIVED },
        {
            text: 'Collected',
            value: state.COLLECTED
        }
    ],
    FILTER_STATUSES: (state, getters) => [
        ...getters.ALL_STATUSES,
        {
            text: 'Refunded',
            value: state.REFUNDED
        },
        {
            text: 'Cancelled',
            value: state.CANCELLED
        }
    ],
    CREATED: state => state.CREATED,
    SENT: state => state.SENT,
    SHIPPING: state => state.SHIPPING,
    ARRIVED: state => state.ARRIVED,
    COLLECTED: state => state.COLLECTED,
    REFUNDED: state => state.REFUNDED,
    CANCELLED: state => state.CANCELLED,
    PAYMENT_METHOD_CREDIT: state => state.PAYMENT_METHOD_CREDIT,
    PAYMENT_METHODS: state => [
        state.PAYMENT_METHOD_STARS,
        state.PAYMENT_METHOD_MANUAL,
        state.PAYMENT_METHOD_CREDIT,
        state.PAYMENT_METHOD_CREDIT_AND_STARS
    ]
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    index(
        ctx,
        {
            userId = null,
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters = null
        }
    ) {
        const params = {
            userId,
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get('/admin/orders', { params });
    },

    refund(ctx, id) {
        return axios.$post(`admin/orders/${id}/refund`);
    }
};
